import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useOffersTotal } from '@hooks';
import { useCurrentShopQuery } from '../../hooks/useCurrentShopQuery';
import { useOnboarding } from './useOnboarding';
export const useHome = () => {
    const { onboarding } = useOnboarding();
    const offersTotal = useOffersTotal();
    const { currentShopQuery } = useCurrentShopQuery();
    useEffect(() => {
        if (offersTotal?.all) {
            TagManager.dataLayer({
                dataLayer: { event: 'offers_count', offersCount: offersTotal?.all },
            });
        }
    }, [offersTotal?.all]);
    const getName = () => {
        if (!currentShopQuery.data?.primaryDomain)
            return '';
        if ((onboarding.onboardingType === 'SCHEDULER' ||
            onboarding.onboardingType === 'ONBOARDING_SHOP' ||
            onboarding.onboardingType === 'ONBOARDING_SHOP_MEMBERSHIPS') &&
            !currentShopQuery?.data.lastLiveAt) {
            return 'You’re just a few steps away from launch!';
        }
        return '';
    };
    return {
        name: getName(),
    };
};
